import {
  addComponentsDir,
  addPluginTemplate,
  createResolver,
  defineNuxtModule,
} from '@nuxt/kit'

export default defineNuxtModule({
  meta: {
    name: 'biginUi',
    configKey: 'biginUi',
    compatibility: {
      nuxt: '>=4.0.0',
    },
  },
  setup(_options, nuxt) {
    const { resolve } = createResolver(import.meta.url)

    addComponentsDir({
      path: resolve('./components'),
      pattern: '*/index.mjs',
      prefix: 'b',
      ignore: [
        'collection/index.mjs',
        'slot/index.mjs',
        'virtual-list/index.mjs',
      ],
    })

    if (nuxt.options.ssr !== false) {
      addPluginTemplate({
        filename: 'bigin-ui-id-injection.plugin.mjs',
        getContents: () => `
import { defineNuxtPlugin } from '#app'
import { ID_INJECTION_KEY } from 'bigin-ui'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(ID_INJECTION_KEY, {
    prefix: Math.floor(Math.random() * 10000),
    current: 0,
  })
})
`,
      })
    }
  },
})

declare module '@nuxt/schema' {
  interface NuxtConfig {
    biginUi?: Record<string, unknown>
  }
  interface NuxtOptions {
    biginUi?: Record<string, unknown>
  }
}
